import {
  TubeframeDimensionsFields,
  TubeframeJointFields,
  TubeframeParamsSync,
} from './TubeframeFields';

// Land → Tubeframe Joint content — the LEGACY single pane (feature-tree-windows
// flag OFF, prod default). The field ROWS were factored into TubeframeFields so
// the exact same controls can also render split across the "Dimensions"/"Joint"
// floating windows when the flag is ON; this component simply stacks both
// groups, preserving the original layout and behavior byte-for-byte. The
// always-mounted TubeframeParamsSync publishes readiness to homepage-context (it
// used to be a useEffect inside this component) so Generate stays wired whether
// the fields live here or in the windows.
export function LandContent({ enabled }: { enabled: boolean }) {
  return (
    <div>
      <TubeframeParamsSync />
      <div className="mt-2 space-y-3">
        <TubeframeDimensionsFields enabled={enabled} />
        <TubeframeJointFields enabled={enabled} />
      </div>
    </div>
  );
}
